import { notEmpty } from '../utils';
export function fetchingStatus(state) {
    return state.categoryTree.meta.status;
}
export function category(state, categoryId) {
    return state.categoryTree.categoryCache[categoryId];
}
export function categories(state, { parentCategoryId, limit, }) {
    let _categories = [];
    if (!parentCategoryId || parentCategoryId === 'root') {
        _categories = state.categoryTree.topLevelcategoryIds;
    }
    else {
        const c = category(state, parentCategoryId);
        if (c)
            _categories = c.subCategories;
    }
    const totalCount = _categories.length;
    if (limit)
        _categories = _categories.slice(0, limit);
    return {
        categories: _categories.map((c) => category(state, c)).filter(notEmpty),
        totalCount,
    };
}
export function articleFragment(state, articleId) {
    return state.categoryTree.articleCache[articleId];
}
export function articleFull(state, articleId) {
    return state.categoryTree.articleFullCache[articleId];
}
export function relatedArticles(state, articleId) {
    const article = articleFull(state, articleId);
    if (!article)
        return null;
    return article.relatedArticles
        .map((a) => articleFragment(state, a))
        .filter(notEmpty);
}
export function articles(state, categoryId, { limit } = {}) {
    const cat = category(state, categoryId);
    if (!cat) {
        return {
            articles: [],
            totalCount: 0,
        };
    }
    let _articles = cat.articles;
    if (limit)
        _articles = _articles.slice(0, limit);
    return {
        articles: _articles.map((a) => articleFragment(state, a)).filter(notEmpty),
        totalCount: cat.articles.length,
    };
}
//# sourceMappingURL=categoryTree.js.map